import { useCssModule, computed } from "vue";
function useLoadingProp() {
  function createLoadingProp(defaultValue = false) {
    return {
      loading: {
        type: Boolean,
        default: defaultValue
      }
    };
  }
  function getLoadingClass(props) {
    const $style = useCssModule();
    const loadingClass = computed(() => ({
      [$style.isLoading]: props.loading
    }));
    return {
      loadingClass
    };
  }
  return {
    createLoadingProp,
    getLoadingClass
  };
}
export {
  useLoadingProp as u
};
